import { deepCopy } from '@/utils/utils';

export class PreviewSandbox {
  constructor(store) {
    this.store = store;
    this.baseline = null;
    this.active = false;
  }

  capture() {
    const s = this.store.state;
    this.baseline = {
      componentData: deepCopy(s.componentData),
      curComponent: deepCopy(s.curComponent),
      curComponentIndex: s.curComponentIndex,
      pageOptions: deepCopy(s.pageOptions),
      selectedCurrentPage: s.selectedCurrentPage,
      isChildPage: s.isChildPage,
      canvasAllData: deepCopy(s.canvasAllData),
      snapshotData: deepCopy(s.snapshotData),
      snapshotIndex: s.snapshotIndex,
      areaData: deepCopy(s.areaData),
    };
    this.active = true;
  }

  restore() {
    if (!this.baseline) return;
    const b = this.baseline;
    this.store.commit('setComponentData', b.componentData);
    this.store.commit('setCurComponent', {
      component: b.curComponent,
      index: b.curComponentIndex,
    });
    this.store.commit('setPageOptions', b.pageOptions);
    this.store.commit('setSelectedCurrentPage', b.selectedCurrentPage);
    if (b.canvasAllData !== undefined) {
      this.store.commit('setCanvasAllData', b.canvasAllData);
    }
    if (b.areaData) {
      this.store.commit('setAreaData', b.areaData);
    }
    this.store.state.snapshotData = b.snapshotData;
    this.store.state.snapshotIndex = b.snapshotIndex;
    this.active = false;
    this.baseline = null;
  }

  commit() {
    this.active = false;
    this.baseline = null;
    this.store.commit('recordSnapshot');
  }

  isActive() {
    return this.active;
  }
}
